import {
  Button,
  Flex,
  HStack,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  useColorModeValue,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { Download, FileText, FolderDown } from "lucide-react";
import { ViewToggle, type ViewMode } from "./ViewToggle";

export interface CandidateListToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  selectedCount: number;
  /** Omitido = botão "Baixar Documentos" não aparece (ex.: tela de Processos RH). */
  onDownload?: () => void;
  onExport: () => void;
  /** Omitido = botão "Carta Proposta" não aparece. */
  onCartaProposta?: () => void;
  /** Omitidos = toggle de visualização não aparece. */
  viewMode?: ViewMode;
  onViewModeChange?: (mode: ViewMode) => void;
}

export const CandidateListToolbar = ({
  search,
  onSearchChange,
  selectedCount,
  onDownload,
  onExport,
  onCartaProposta,
  viewMode,
  onViewModeChange,
}: CandidateListToolbarProps) => {
  const inputBg = useColorModeValue("white", "#0f2040");

  return (
    <Flex gap={2} mb={3} align="center">
      <InputGroup maxW="280px" size="sm" flex={1}>
        <InputLeftElement pointerEvents="none">
          <SearchIcon color="gray.400" />
        </InputLeftElement>
        <Input
          placeholder="Buscar por nome ou e-mail..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          bg={inputBg}
          borderRadius="lg"
        />
      </InputGroup>

      <HStack ml="auto" spacing={2}>
        {viewMode && onViewModeChange && (
          <ViewToggle value={viewMode} onChange={onViewModeChange} />
        )}
        {onDownload && (
          <Button
            size="sm"
            leftIcon={<Icon as={FolderDown} boxSize={4} />}
            colorScheme="ggBlue"
            variant={selectedCount > 0 ? "solid" : "outline"}
            onClick={onDownload}
          >
            Baixar Documentos
          </Button>
        )}
        {onCartaProposta && (
          <Button
            size="sm"
            leftIcon={<Icon as={FileText} boxSize={4} />}
            colorScheme="ggBlue"
            variant={selectedCount > 0 ? "solid" : "outline"}
            isDisabled={selectedCount === 0}
            onClick={onCartaProposta}
          >
            Carta Proposta
          </Button>
        )}
        <Button
          size="sm"
          leftIcon={<Icon as={Download} boxSize={4} />}
          colorScheme="ggBlue"
          variant="outline"
          onClick={onExport}
        >
          Exportar Excel
        </Button>
      </HStack>
    </Flex>
  );
};
